import iqosBleService from './ble/iqosBleService.js';
import connectivityService from './device/connectivityService.js';
import {log} from './log.js';

export async function connectToBLE({
    isNewDevice,
    onDeviceInitialization,
    onError,
    onDeviceSelect,
    retryNumber,
    isPairingDelayOnWindowsEnabled,
}) {
    connectivityService.setIsBle();
    log.info('Connecting to BLE device...');

    try {
        await iqosBleService.connect({
            isNewDevice,
            onDeviceInitialization,
            onDeviceSelect,
            retryNumber,
            isPairingDelayOnWindowsEnabled,
        });
    } catch (e) {
        log.info(`connectToBLE: device connection failed, error: ${e}`);

        iqosBleService.disconnect();

        onError?.(e);
    }
}
